/** Sentinel sent to the API to filter rows where the enum column is NULL. */
export const FILTER_EMPTY_VALUE = -9999;

/** Frontend-only marker for boolean columns with NULL values. */
export const FILTER_BOOLEAN_EMPTY = 'empty' as const;

export type BooleanFilterValue = boolean | typeof FILTER_BOOLEAN_EMPTY | null;
